export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7635.d1101957.jpg";